import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from 'src/app/core';
import { AppComponent } from 'src/app/app.component';
import { RolePrivilegeManagerService } from 'src/services/service/role-privilege-manager.service';
import { User } from '../model/user.model';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  showSidebar = false;
  user: User;
  activeLink:string = "";
  role: any;

  constructor(private app: AppComponent,
              private authService: AuthenticationService,
              private route: ActivatedRoute,
              private router: Router,
              private rolePrivilegeManager:RolePrivilegeManagerService) {
    this.role = this.app.currentRole;
      this.activeLink = this.router.url;
      if (this.activeLink == "" || this.activeLink == "/"){
        this.route.url.subscribe(response => {
          this.activeLink = response[0]['path'];
        });
      }
  }

  get currentUser() { return JSON.parse(sessionStorage.getItem('currentUser')); }

  get isLoggedIn() { return this.authService.isLoggedIn(); }

  get returnUrl() { return  this.authService.getLandingPage(); }


  ngOnInit() {
  }

  logout() {
    this.authService.logout('LOGGED_OUT');
    this.router.navigate(['/']);
  }

  onClickBar() {
    this.showSidebar = true;
  }

  closeSideBar($event) {
    this.showSidebar = $event;
  }
  DATA_ENTRY_OFFICER = this.rolePrivilegeManager.dataEntryOfficer();
  NOT_DATA_ENTRY_OFFICER = this.rolePrivilegeManager.notDataEntryOfficer();
  CREATE_ACCREDITED_AGENT = this.rolePrivilegeManager.accreditedAgent();
}
